// extracted by mini-css-extract-plugin
export var borderRadius = "_5c-4";
export var large = "_5c-3";
export var logoContainer = "_5c-0";
export var nameLogo = "_5c-2";
export var small = "_5c-1";